import { useLocation } from "react-router";

const queryString = require('query-string');

export const useQuery = () => {
  const location = useLocation();
  return queryString.parse(location.search);
}
